<template>
  <v-container>
    <h2 class="ccm-title">
      {{ title }}
    </h2>

    <div class="d-flex flex-wrap justify-space-around">
      <v-card
        v-for="one in steps"
        :key="one.iso"
        class=""
        max-width="250"
        flat
        style="background-color: transparent"
      >
        <v-img
          :src="one.pictureUrl"
          :lazy-src="one.pictureLazyUrl"
          height="150px"
          contain
        ></v-img>

        <v-card-text class="ccm-text" v-html="one.description"></v-card-text>

      </v-card>
    </div>
  </v-container>
</template>

<script>
export default {
  props: {
    title: String,
    steps: Array
  }
}
</script>

<style scoped>
.ccm-title {
  /* color:#0b755f; */
  font-size: 2em;
  text-align:center;
  padding-bottom: 1em;
}

.ccm-text {
  font-size: 16px;
  text-align: center;
  word-break:normal
}
</style>